import { createUUID, IObject } from "../../../shared/utils/utils";

export interface IColumn {
  field: string;
  field_type: string | undefined;
  agg: string;
  aggregator_title: string;
  agg_datatype: string;
}

export function transformToBackendDatamodelReportConfiguration(data: any) { // eslint-disable-line
  const configuration = {
    datamodel_type: data.datamodel_type,
    datamodel_id: data.datamodel_id,
    group_by: data.group_by,
    group_by_datatype: data.group_by_datatype,
    filters: (data.query_filters || []).map((filter: IObject) => ({
      field: filter.field,
      op: filter.op,
      value: filter.value,
    })),
    columns: (data.columns || []).map((col: IObject) => ({
      field: col.field,
      agg: col.agg,
      aggregator_title: col.aggregator_title,
      agg_datatype: col.agg_datatype
    })),
  };

  return {
    id: data.id || createUUID(),
    name: data.name,
    configuration: JSON.stringify(configuration),
  };
}

export function transformFromBackendDatamodelReportConfiguration(backendData: any) { // eslint-disable-line
  let parsedConfig: any = {}; // eslint-disable-line

  try {
    parsedConfig = JSON.parse(backendData.configuration);
  } catch (e) {
    console.error("Failed to parse configuration JSON:", e);
  }

  const columns: IColumn[] = parsedConfig.columns.map((col: IObject) => ({
    field: col.field,
    field_type: col.field_type,
    agg: col.agg,
    aggregator_title: col.aggregator_title,
    agg_datatype: col.agg_datatype
  }));

  return {
    id: backendData.id,
    name: backendData.name,
    datamodel_type: parsedConfig.datamodel_type,
    datamodel_id: parsedConfig.datamodel_id,
    group_by: parsedConfig.group_by,
    group_by_datatype: parsedConfig.group_by_datatype,
    query_filters: parsedConfig.filters || [],
    columns,
    created_at: backendData.created_at,
  };
}
